import React from 'react';
import { Kicker, FadeUp, CharReveal } from './ui';
const QUOTES = [{
  quote: 'They rebuilt our brand and the numbers followed. Signups tripled in the first quarter after launch.',
  name: 'Ada Nwosu',
  role: 'CEO, Danfo Pay',
  img: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&q=80'
}, {
  quote: 'The first agency that argued with us. They were right every single time, and the work shows it.',
  name: 'T. Coleman',
  role: 'Founder, Harmattan Audio',
  img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80'
}, {
  quote: 'Fast, opinionated, precise. Our site finally sounds like us instead of sounding like everyone else.',
  name: 'M. Adeyemi',
  role: 'CMO, Ilé Homes',
  img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80'
}];
export function Testimonials() {
  return <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32" data-id="element-192">
      <Kicker ig="Olu Ndị Ahịa" en="Client voices" data-id="element-193" />
      <h2 className="font-display uppercase text-5xl md:text-8xl tracking-tight mt-4" data-id="element-194">
        <CharReveal text="Receipts" data-id="element-195" />
      </h2>

      <div className="mt-12 md:mt-16 grid gap-6 md:grid-cols-3" data-id="element-196">
        {QUOTES.map((q, i) => <FadeUp key={q.name} delay={i * 130} className="h-full" data-id="element-197">
            <figure className="flex h-full flex-col justify-between rounded-2xl border p-8 md:p-10" style={{
          background: 'var(--ink-2)',
          borderColor: 'var(--line)'
        }} data-id="element-198">
              <div data-id="element-199">
                <span className="font-display text-5xl leading-none" style={{
              color: 'var(--danfo)'
            }} aria-hidden="true" data-id="element-200">
                  “
                </span>
                <blockquote className="mt-4 text-base md:text-lg leading-relaxed" data-id="element-201">{q.quote}</blockquote>
              </div>
              <figcaption className="mt-8 flex items-center gap-4" data-id="element-202">
                <img src={q.img} alt={q.name} loading="lazy" className="h-12 w-12 rounded-full object-cover border" style={{
              borderColor: 'var(--line)'
            }} data-id="element-203" />
                <span data-id="element-204">
                  <p className="font-monoui text-xs uppercase tracking-[0.18em]" data-id="element-205">{q.name}</p>
                  <p className="font-monoui text-[11px] uppercase tracking-[0.18em] opacity-50 mt-1" data-id="element-206">{q.role}</p>
                </span>
              </figcaption>
            </figure>
          </FadeUp>)}
      </div>
    </section>;
}